import { TypographyProps } from '@global-engineering-shared/gweb-material-types';
import { Typography } from '@global-engineering-shared/gweb-material-ui';
import clsx from 'clsx';

import EntityDetailValue from 'features/EntityDetails/components/EntityDetails/EntityDetail/components';
import useStyles from 'features/EntityDetails/components/EntityDetails/IdentifiableEntityDetail/IdentifiableEntityDetail.styles';
import { IdentifiableEntity } from 'types/detailsEntityType';
import { getSafeDetailValue } from 'utils/getNullSafeValue';
import { truncateText } from 'utils/truncateText';

type IdentifiableEntityDetailProps = {
  label: string;
  entity: IdentifiableEntity | null;
  previousEntity?: IdentifiableEntity | null;
  layout?: 'inline' | 'stacked';
  variant?: TypographyProps['variant'];
  showLabel?: boolean;
};

const IdentifiableEntityDetail = ({
  label,
  entity,
  previousEntity,
  layout = 'inline',
  variant = 'body2',
  showLabel = true,
}: IdentifiableEntityDetailProps) => {
  const classes = useStyles();
  const containerClass = clsx({
    [classes.inline]: layout === 'inline',
    [classes.stacked]: layout === 'stacked',
  });

  const renderLabel = () =>
    showLabel && (
      <Typography
        data-testid={`${layout}-label`}
        variant={variant}
        color={layout === 'stacked' ? 'textSecondary' : 'textPrimary'}
      >
        {layout === 'inline' ? `${label}: ` : label}
      </Typography>
    );

  return (
    <div className={containerClass}>
      {renderLabel()}
      {/*TODO: add tooltip*/}
      <EntityDetailValue
        label={label}
        value={truncateText(getSafeDetailValue(entity?.name), 60)}
        previousValue={truncateText(getSafeDetailValue(previousEntity?.name), 60)}
        variant={variant}
      />
    </div>
  );
};

export default IdentifiableEntityDetail;
